
import createFeatureManagementInstance from '@justeat/feature-management';
import axios from "axios";

const sixtySeconds = 60 * 1000;
const fiveSeconds = 5000;

class JetFmLog {
  info(message, tags, payload = {}) {
    console.info("[jetfm]", message, tags, payload);
  }

  warn(message, tags, payload = {}) {
    console.warn("[jetfm]", message, tags, payload);
  }

  error(message, exception, tags, payload = {}) {
    console.error("[jetfm]", message, exception, tags, payload);
  }
}

export class JetFm {
  constructor() {
    this.service = null;
  }


  init() {
    const config = 
    {
      keyPrefix: 'jet-minisites',
      cdn: {
        host: 'https://features.api.justeattakeaway.com',
        scope: 'jet-minisites',
        environment: process.env.NODE_ENV || 'development',
        key: '',
        poll: true,
        pollInterval: sixtySeconds, // default value in docs
      },
      contextGetter: () => {        
        return { appVersion: '1.2.3', tenant: 'all' };
      },
      onTrack: (key, variant) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'experiment_active',
          tms_data: {
              eventData: {
                  experiment_variant: variant,
                  experiment_key: key,
              }
          }
      })
      },
    };

    config.log = new JetFmLog();
    const httpClient = axios.create({
      timeout: fiveSeconds
  });

const service = createFeatureManagementInstance(config, httpClient);
const self = this;
service.loadFromCdn()
    .then(() => {
        self.service = service;        
        self.service.getBooleanValue("feature_show_ordermodule");
        return self;
    })
    .catch(error => {
        config.log.error('Error loading from JETFM', error);
    });
  }
}